
import { PriceServiceP } from "./priceServiceP.model";
import { PriceDVGT } from "./priceDVGT.model";
import { PromotionDetail } from "./promotionDetail.moddel";
import { PriceServiceDetail } from "./priceServiceDetail.Model";


export class Price {

    defaultPrice: number;
    defaultPriceS: number;
    defaultPriceP: number;
    totalDVGT: number;
    remoteAreasPrice: number;
    fuelPrice: number;
    otherPrice: number;
    vatPrice: number;
    totalPrice: number;
    priceDVGTs: PriceDVGT[];
    priceService : PriceServiceP;
    priceCPNDetails : any[]=[];
    dim: number;
    priceReturn: number;
    priceCOD: number;
    totalPriceSYS: number;
    deadlineDelivery: any;
    calWeight:any;
    pricePayment:number;
    promotionPrice:number;
    promotionDetail: PromotionDetail[]=[];
    totalPriceRound: number;
    originalPrice: number = 0;
    listBoxs:any[];
}